import TimelineItemPersonalArea from './TimelineItemPersonalArea';

export default TimelineItemPersonalArea;
